import React, { FC } from 'react';
import { Loader } from '../../../components/Loader/Loader';
import { Modal } from './Modal';

export const Loading: FC<{ loading?: boolean; refetching?: boolean }> = ({
  loading,
  refetching,
}) =>
  refetching ? (
    <div
      style={{
        position: 'absolute',
        top: 76,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        left: 'calc(50% - 16px)',
        width: 32,
        height: 32,
        borderRadius: 4,
        backgroundColor: '#ffffff',
        zIndex: 1000,
      }}
    >
      <Loader size="small" />
    </div>
  ) : loading ? (
    <Modal>
      <Loader size="xxl" />
    </Modal>
  ) : null;
